import React from 'react';
import DatePicker from "react-datepicker";
import DatePickerWrapper from './DatePickerWrapper';
import ComponentLink from './ComponentLink';
import EffectiveDate from './EffectiveDate';
import Loader from 'react-loader';
import * as utils from '../util';
import { connect } from 'react-redux';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';
import { history } from '../store';

const mapStateToProps = state => ({
    ...state.common
  });

class FixedPeriodGrid extends React.Component {

    lagOptions = this.props.lagOptions;
    getLagsBtns = () => {
        let btns = [];
        for (let i = 0; i < this.lagOptions.length; i++) {
            btns.push(
                <button key= {i} onClick={() => { this.props.handleLagChange(this.lagOptions[i] + 'd') }} className="dropdown-item" type="button">{this.lagOptions[i] + 'd'} </button>
            );
        }
        return btns;
    }

    getFallbackFinalOutput = (item) =>
    {
        if(this.props.outPut2[item].message!='Success'){
            return 'N/A'
        }else{
            return this.props.outPut2[item].bp_spr_adj+"bp => "+(parseFloat((parseFloat(this.props.outPut2[item].spr_adj) + parseFloat(this.props.outPut1[item].rate)))).toFixed(4) +"%";
        }
    }
    getFallbackTitle = (item) =>
    {
        if(this.props.outPut2[item].message!='Success'){
            return 'N/A'
        }else{
            return "Median Period Start Date: "+this.props.outPut2[item].spr_adj_start_date +
        ", End Date: "+this.props.outPut2[item].spr_adj_end_date +
        ", Spread Adjustment: "+this.props.outPut2[item].spr_adj +
        ", Projected Rates: "+this.props.outPut2[item].is_projected_rates_used;
        }
    }
    render() {
        var instrumentType = this.props.instrumentType ? this.props.instrumentType : null
        var date = this.props.endDate ? this.props.endDate.toISOString() : null;
        const maxDate = new Date().toDateString()
        const style = { width: '100px', height: '25px', fontSize: '13px' };

        var rows = utils.periods.map((item, i) => {
            var startDate = new Date(utils.getStartDate(date, item));
            return (
                <tr key={i}>
                    <td className="tableCell">
                        <div className="content">{item}
                            {/* { i==0 && instrumentType=='SONIA' && !this.props.isAuthenticated ?  <span><sup className="redText">*</sup></span> : null} */}
                        </div>
                    </td>
                    <td className="tableCell textMinWid">
                        <div className="content">
                            <EffectiveDate
                                isEffective={this.props.outPut1 && this.props.outPut1[item] && !(this.props.loadingFirstGrid[item]) ? utils.compareDate(startDate, this.props.outPut1[item].effective_start_date) : true}
                                effDate={this.props.outPut1 && this.props.outPut1[item] ? utils.formatDate(new Date(this.props.outPut1[item].effective_start_date)) : ''}
                                value={utils.formatDate(startDate)}
                            />
                        </div>
                    </td>
                    <td className="tableCell textMinWid">
                        <div className="content">
                            <EffectiveDate
                                isEffective={this.props.outPut1 && this.props.outPut1[item] && !(this.props.loadingFirstGrid[item]) ? utils.compareDate(this.props.endDate, this.props.outPut1[item].effective_end_date) : true}
                                effDate={this.props.outPut1 && this.props.outPut1[item] ? utils.formatDate(new Date(this.props.outPut1[item].effective_end_date)) : ''}
                                value={utils.formatDate(new Date(date))}
                            />
                        </div>
                    </td>

                    {(this.props.fallbackToggle==false) ? 
                    <td className="tableCell">
                        {this.props.loadingFirstGridRealRate[item] ? <Loader className="loader" color='#6f2c91' scale={0.49} loaded={false} /> :
                            this.props.isGridOneRealRateError[item] || this.props.outPut2 === null ? <div className='content'>{"Error"}</div> : <ComponentLink value={this.props.outPut2[item].rate} url={utils.createGridOneUrl(instrumentType, this.props.endDate, item, 0, this.props.resetType)} pad={4} apiResponse={JSON.stringify(this.props.outPut2[item])} />}
                    </td> :
                    null
                    }

                    <td className="tableCell">
                        {this.props.loadingFirstGrid[item] ? <Loader className="loader" color='#6f2c91' scale={0.49} loaded={false} /> :
                            this.props.isGridOneError[item] || this.props.outPut1 === null ? <div className='content'>{"Error"}</div> : <ComponentLink value={this.props.outPut1[item].rate} url={utils.createGridOneUrl(instrumentType, this.props.endDate, item, this.props.lag, this.props.resetType)} pad={4} apiResponse={JSON.stringify(this.props.outPut1[item])} />}
                    </td>
                    {(this.props.fallbackToggle==true) ? 
                    <td className="tableCell">
                    {this.props.loadingFirstGridFallbackRate[item] ? <Loader className="loader" color='#6f2c91' scale={0.49} loaded={false} /> :
                            this.props.isGridOneFallbackRateError[item] || this.props.outPut2 === null ? <div className='content'>{"Error"}</div> : <ComponentLink title={this.getFallbackTitle(item)} value={this.getFallbackFinalOutput(item)} url={utils.createGridOneFallbackUrl(instrumentType, this.props.calcDate, item)} pad={4} apiResponse={JSON.stringify(this.props.outPut2[item])} />}
                    </td> :
                    null
                    }
                    

                </tr>
            )
        });
        return (
            <div className='table-responsive mt-15'>
                <table key={'risk_tbl'} className="table table-striped">
                    <thead>
                        <tr key={'risk_tbl_head'}>
                            <th className="col-md-1 tableCell">Term</th>
                            <th className="col-md-2 tableCell">Start</th>
                            <th className="col-md-2 table-custom-head tableCell textMinWid">
                                <div className="comboComp">
                                    <label className="alignComboR10">
                                        End
                                        </label>
                                    <DatePicker
                                        selected={this.props.endDate}
                                        onChange={this.props.handleDateChange}
                                        maxDate={this.props.maxDate15}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        dateFormat="dd/MM/yyyy"
                                        yearDropdownItemNumber={15}
                                        customInput={<DatePickerWrapper />}
                                    />
                                </div>
                            </th>
                            {this.props.fallbackToggle==false?<th className="col-md-2 tableCell">Realised Rate</th>:null}
                            <th className="col-md-2 table-custom-head tableCell">
                                {this.props.fallbackToggle==true? <div><label>Realised Rate</label></div>:null}
                                <div className="comboComp">
                                    <div className="dropdown">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Lag in business days">
                                            {this.props.lag}
                                        </button>
                                        <div className="dropdown-menu col-md-3" aria-labelledby="dropdownMenu2">
                                            {
                                                this.getLagsBtns()
                                            }
                                        </div>
                                    </div>
                                    <label className="alignComboL10" title="Lag in business days">
                                        Lag
                                </label>
                                </div>
                            </th>
                            {(this.props.fallbackToggle==true) ?
                            <th className="col-md-2 table-custom-head tableCell textMinWid">
                                <div>
                                    <label className="alignComboR10" title={"Data as of "+this.props.todaysFallbackDate}>
                                        Estimated Fallback<sup className="redText">2</sup> 
                                            <a className="text-purple" onClick={() => { history.push('./Fallback') }}><FaQuestionCircle /></a>
                                    </label>
                                </div>
                                <div className="comboComp">
                                    <label className="alignComboR10">Calc Date</label>
                                    <DatePicker
                                        selected={this.props.calcDate}
                                        onChange={this.props.handleFallbackDateChange}
                                        maxDate={this.props.fallbackMaxDate}
                                        minDate={this.props.fallbackMinDate}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        dateFormat="dd/MM/yyyy"
                                        yearDropdownItemNumber={15}
                                        customInput={<DatePickerWrapper />}
                                    />
                                </div>
                                </th>:null}
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default connect(mapStateToProps)(FixedPeriodGrid);


// WEBPACK FOOTER //
// ./src/components/FixedPeriodGrid.js